<template>
  <div class="account">

    <v-card class="white" >
      <v-container fluid grid-list-lg>
        <v-layout row v-if="(getPermissions)">
          <v-flex xs12 sm5>
            <div>
              <v-btn 
                color="primary"
                block
                :href="Domaine"
                target="_blank"
              >
                {{ $t('accountVoir') }}
                <v-icon right>card_membership</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-card>
      <!-- Bouton de modification du profil -->
      <v-card-text style="padding: 0px; position: relative">
        <v-fab-transition>
          <v-btn
            color="secondary"
            dark
            absolute
            bottom
            right
            fab
            v-show="showFab"
            @click.native.stop="openDialog()">
              <v-icon >edit</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-card-text>

      <v-flex  xs12>
        <v-expansion-panel expand>

          <!-- Infos de l'utilisateur -->
          <v-expansion-panel-content>
            <div slot="header">
              <v-subheader>{{ $t('accountInfo') }}</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense>
                <!-- SITE -->
                <v-list-tile>
                  <v-list-tile-content>
                    <wz-select-one-site></wz-select-one-site>
                  </v-list-tile-content>
                </v-list-tile>
                <div>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="primary--text">mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ siteSelected.LIC_CONTACTS }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('accountDest') }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="primary--text">contact_mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ siteSelected.LIC_CONTACT_COPY }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('accountDest2') }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="primary--text">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ siteSelected.LIC_CALLBACK_PHONE }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('accountNum') }} (Click to Call)</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card>
          </v-expansion-panel-content>

          <!-- Infos de l'abonnement -->
          <v-expansion-panel-content>
            <div slot="header">
              <v-subheader>{{ $t('accountInfo2') }}</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense>
                <v-list-tile v-if="user.entRefFacturation">
                  <v-list-tile-action>
                    <v-icon class="primary--text">person</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entRefFacturation.CLI_EMAIL }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountRefe') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">vpn_key</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entKey }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountCle') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">poll</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ level.title }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountFormu') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="(isLevelFaq())">
                  <v-list-tile-action>
                    <v-icon class="primary--text">chat</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title> 1 </v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('ChatSimulMax') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="(getPermissions)">
                  <v-list-tile-action>
                    <v-icon class="primary--text">contact_mail</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entNbPageThisMonth }} / {{ user.entNbPageMax }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountNb') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">cake</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entEezyExpiry }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountDate') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="(getPermissions)">
                  <v-list-tile-action>
                    <v-icon class="primary--text">group</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entNbAgent }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountConseil') }}</v-list-tile-sub-title>{{ $t('xxx') }}
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="(getPermissions)">
                  <v-list-tile-action>
                    <v-icon class="primary--text">language</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ user.entNbSite }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountSites') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
              
          <!-- Infos sur les options -->
          <v-expansion-panel-content v-if="(getPermissions)">
            <div slot="header">
              <v-subheader>{{ $t('accountListe') }}</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense>
                <v-list-tile v-for="(option, key) in options" :key="key">
                  <v-list-tile-action>
                    <v-icon class="primary--text">{{ option.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ key }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ option.value ? $t('yes') : $t('no') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>       
       
          <!-- Infos sur Flying First -->
          <!-- <v-expansion-panel-content v-if="flying.credit !== 0"> -->
          <v-expansion-panel-content v-if="(getPermissions)">
            <div slot="header">
              <v-subheader>Flying First</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">flight_takeoff</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('accountCredits') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ flying.credit }} minutes</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">flight_land</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('accountDebits') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ flying.debit }} minutes</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

              <div class="tf_fliyng_first">
                <v-list dense>
                  <!-- <v-list-group v-model="item" color="primary"> -->
                    <v-list-tile v-for="(debit, key) in flying.debitDesc" :key="key">
                      <v-list-tile-icon>
                      </v-list-tile-icon>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ flying.debitDate[key] }} : {{ debit }} ( {{ flying.debitDuration[key] }} )</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  <!-- </v-list-group > -->
                </v-list>
              </div>
            </v-card>
          </v-expansion-panel-content>

          <!-- Infos sur Eezy Lead -->
          <v-expansion-panel-content v-if="getPermissions && lead.credit[siteSelected.LIC_ID] && lead.credit[siteSelected.LIC_ID] !== 0">
            <div slot="header">
              <v-subheader>Eezy Lead </v-subheader>
            </div>
            <v-card>
              <br>
              <v-list-tile>
                <v-list-tile-content>
                  <wz-select-one-site></wz-select-one-site>
                </v-list-tile-content>
              </v-list-tile>
              <v-list two-line dense>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">add_shopping_cart</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('accountCredits') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ lead.credit[siteSelected.LIC_ID] ? lead.credit[siteSelected.LIC_ID] : 0}} €</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">how_to_reg</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('accountDebits') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ lead.debit[siteSelected.LIC_ID] ? lead.debit[siteSelected.LIC_ID] : 0}} €</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-for="(debit, key) in lead.debitDesc[siteSelected.LIC_ID]" :key="key">{{ debit }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <br>
            </v-card>
          </v-expansion-panel-content>
          
          <!-- Infos option callback -->
          <v-expansion-panel-content v-if="getPermissions && callback === '1'">
            <div slot="header">
              <v-subheader>Call Back</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense >
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">local_phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <!--<v-list-tile-title>{{ callback_fixe }}</v-list-tile-title>-->
                    <v-list-tile-title>{{ siteSelected.c2c_conso_f ? siteSelected.c2c_conso_f : '00:00:00' }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountFixe') }} {{ siteSelected.c2c_quota_sites_f ? siteSelected.c2c_quota_sites_f : '0' }} {{ $t('accountHeures') }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="siteSelected.c2c_conso_sec_f && siteSelected.c2c_quota_sites_f">{{ $t('accountYour') }} {{ Math.round(siteSelected.c2c_conso_sec_f * 100 / (3600 * siteSelected.c2c_quota_sites_f))}} % {{ $t('accountDuquota') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">phone_iphone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <!--<v-list-tile-title>{{ callback_mobile }}</v-list-tile-title>-->
                    <v-list-tile-title>{{ siteSelected.c2c_conso_m ? siteSelected.c2c_conso_m : '00:00:00' }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountMobi') }} {{ siteSelected.c2c_quota_sites_m ? siteSelected.c2c_quota_sites_m : '0' }} {{ $t('accountHeures') }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="siteSelected.c2c_conso_sec_m && siteSelected.c2c_quota_sites_m">{{ $t('accountYour') }} {{ Math.round(siteSelected.c2c_conso_sec_m * 100 / (3600 * siteSelected.c2c_quota_sites_m))}} % {{ $t('accountDuquota') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
        

          <!-- Infos sur SMS -->
          <v-expansion-panel-content v-if="getPermissions && sms === '1'">
            <div slot="header">
              <v-subheader>SMS</v-subheader>
            </div>
            <v-card>
              <v-list two-line dense >
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text">phone_iphone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ sms_conso ? sms_conso : '0' }} SMS (textos) {{ $t('accountSend') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('accountConso') }} {{ siteSelected.sms_quota ? siteSelected.sms_quota : '0' }} SMS</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="sms_conso && siteSelected.sms_quota">{{ $t('accountYour') }} {{ Math.round(sms_conso * 100 / (siteSelected.sms_quota))}} % {{ $t('accountDuquota') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>
      </v-flex>
    </v-card>

    <!-- DIALOGUE D'ÉDITION DES CONTACTS -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent scrollable max-width="600px">
        <v-card>
          <v-card-title class="primary white--text">
            <span class="headline">{{ $t('accountModif') }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field 
              v-model="siteDialog.LIC_CONTACTS"
              :label="$t('accountContact')" 
              type="email"
              prepend-icon="mail"
              data-vv-name="email"
              v-validate="'required|email'"
              :error="wzErrors.has('email')"
              :error-messages="wzErrors.collect('email')"
            ></v-text-field>
            <v-text-field 
              v-model="siteDialog.LIC_CONTACT_COPY"
              :label="$t('accountCopie')" 
              type="text"
              prepend-icon="mail"
            ></v-text-field>
            <v-text-field 
              v-model="siteDialog.LIC_CALLBACK_PHONE" 
              :label="$t('accountTel')" 
              type="text" 
              disabled
              prepend-icon="phone"
            ></v-text-field>
            <wz-switch-lang :lang.sync="siteDialog.lang"></wz-switch-lang>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="cancel">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click.native="save" :disabled="wzErrors.any()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import permission from '../mixins/permissions'
import { DOMAINE, LEVEL } from '../constants'
import moment from 'moment'
import _ from 'lodash'
export default {
  mixins: [permission],
  data () {
    return {
      name: 'Account',
      // indique si la modification du profil est visible
      dialog: false,
      // objet site qui représente celui dans la fenêtre de dialogue
      siteDialog: {},
      callback: null,
      callback_fixe: null,
      callback_mobile: null,
      options: {
        cobrowsing: { icon: 'open_in_browser', value: false },
        mirroring: { icon: 'remove_red_eye', value: false },
        push: { icon: 'photo_size_select_large', value: false },
        callback: { icon: 'local_phone', value: false }
      },
      flying: {
        debit: 0,
        credit: 0,
        debitDesc: {},
        debitDate: {},
        debitDuration: {}
      },
      lead: {
        debit: 0,
        credit: 0,
        debitDesc: {},
        debitDate: {}
      },
      // Dialogue indiquant que l'utilisateur a fait une modification de ses infos
      showFab: false,
      sms: null,
      sms_conso: 0,
      step: 72,
      dialogProgress: false,
      connexionType: 'targetfirst'
    }
  },

  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'account'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'account'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  methods: {
    // récupération des mutateurs du store
    ...mapMutations('_User', ['setUser', 'setAvatar']),
    ...mapMutations('_Sites', ['UPDATE_SITE_SETTINGS', 'UPDATE_SITE_SELECTED']),

    // sauver les modifs
    save () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('id', this.siteDialog.LIC_ID)
      dataToPost.append('email', this.siteDialog.LIC_CONTACTS)
      dataToPost.append('copy', this.siteDialog.LIC_CONTACT_COPY)
      dataToPost.append('tel', this.siteDialog.LIC_CALLBACK_PHONE)
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_ACCOUNT')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_ACCOUNT'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      // update côté serveur
      // Si changement dans le formulaire alors on fait la requête afin de modifier les données en BDD
      this.loading = true
      this.axios
        .post('put/account.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        // les changements été pris en compte alors changement des valeurs de l'user géré par le store
        .then(response => {
          this.UPDATE_SITE_SETTINGS(this.siteDialog)
          this.UPDATE_SITE_SELECTED(this.siteDialog)
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loading = false
          this.dialog = false
        })
    },
    /**
     * Annule les modifications
     * si l'utilisateur en a déjà faite, l'interpeller
     */
    cancel () {
      this.dialog = false
    },
    openDialog () {
      this.dialog = true
      this.siteDialog = _.clone(this.siteSelected)
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  computed: {
    // récupération des getters du store
    ...mapGetters('_User', [
      'user',
      'fullName',
      'userAvatar',
      'account',
      'level'
    ]),
    ...mapState('_Sites', ['sites', 'siteSelected']),
    Domaine () {
      return `${DOMAINE}/subscription/subscriptions_fr.php`
    }
  },

  mounted () {
    let dataToPost = new window.FormData()
    dataToPost.append('id', this.user.entId)
    this.axios
      .post('post/account.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        this.callback = response.data.callback
        this.callback_fixe = response.data.callback_fixe
        this.callback_mobile = response.data.callback_mobile
        // Donne les options liés au compte
        this.options.cobrowsing.value =
          this.sites.findIndex(site => !!site.DSK_COBROWSING) !== -1
        this.options.mirroring.value =
          this.sites.findIndex(site => !!site.DSK_MIRRORING) !== -1
        this.options.push.value =
          this.level.rights === LEVEL.ENTREPRISE ||
          moment(this.user.entOptionPush).isSameOrAfter(moment(), 'day')
        this.options.callback.value = this.callback === '1'
        this.showFab = true
        this.flying.credit = response.data.flyTotalCrebit
        this.flying.debit = response.data.flyTotalDebit
        this.flying.debitDesc = response.data.fly_debitDesc
        this.flying.debitDate = response.data.fly_debitDate
        this.flying.debitDuration = response.data.fly_debitDuration
        this.lead.credit = response.data.leadTotalCrebit
        this.lead.debit = response.data.leadTotalDebit
        this.lead.debitDesc = response.data.lead_debitDesc
        this.lead.debitDate = response.data.lead_debitDate
        this.sms = response.data.sms
        this.sms_conso = response.data.sms_conso
      })
      .catch()
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      // this.openDialogProgress()
    // }
  }
}
</script>

<style>
.tf_fliyng_first{margin-left: 70px;}
</style>




// WEBPACK FOOTER //
// src/components/Account.vue